import { isIos } from "@/utils/lodash"; // declare const StatusBar: any;

export var androidStatusBarHeight = "padding-top:20px;";
export var getStatusBarHeight = function getStatusBarHeight() {
  try {
    console.log("initialStatusBarHeight android:", window.StatusBar.actualHeight);

    if (window.StatusBar.actualHeight && !isIos()) {
      androidStatusBarHeight = "padding-top:".concat(window.StatusBar.actualHeight, "px");
      return androidStatusBarHeight;
    }

    return androidStatusBarHeight;
  } catch (error) {}
};

if (isIos()) {
  androidStatusBarHeight = "";
}